<template>
  <maker-layout>
    <div>
      <users-list :client="maker"></users-list>
    </div>
  </maker-layout>
</template>

<script>
import { mapState } from 'vuex';
import MakerLayout from '@/views/settings/makers/MakerLayout.vue';
import UsersList from '@/views/settings/UsersList.vue';

export default {
  data: () => ({
  }),
  computed: {
    ...mapState(`ui/settingsMakers`, {
      maker: `currentAdminMaker`,
    }),
  },
  components: {
    MakerLayout,
    UsersList,
  },
};
</script>
